module.exports = __webpack_public_path__ + "static/img/novalloy-interpretive-exhibits.6906f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/view-our-work/novalloy-interpretive-exhibits.jpg
// module id = 436
// module chunks = 0